import { useMutation, useQueryClient } from "react-query";
import { toast } from "components/toastNotification";
import { addOfficeApplianceBrand } from "../api/addOfficeApplianceBrand";
import { IOfficeAppliancesBrand } from "../type";

const useAddOfficeAppliancesBrand = () => {
  const queryClient = useQueryClient();

  const { mutate } = useMutation(
    (brandData: IOfficeAppliancesBrand) => addOfficeApplianceBrand(brandData),
    {
      onSuccess: (res) => {
        if (res === "Duplicate") {
          toast.fire("Failed", "Brand already exists", "error");
        } else {
          toast.fire("Success", "Brand added successfully", "success");
        }
        queryClient.invalidateQueries(["GetOfficeApplianceBrands"]);
      },
      onError: () => {
        toast.fire("Failed", "Failed to add brand", "error");
      },
    }
  );

  return mutate;
};
export default useAddOfficeAppliancesBrand;
